'use client';

import { Box, Stack, Typography } from '@unity/cloud-ui';
import z from 'zod';
import { getComponentDocumentationUrl } from '@/utils/get-component-doc-url';

export const Frame = (props: z.input<typeof frameSchema>) => {
  return (
    <Stack
      component="figure"
      p={1}
      borderRadius={2}
      width="100%"
      alignItems="center"
      margin={0}
      border={({ vars }) => `1px solid ${vars.palette.divider} !important`}
      sx={{
        backgroundColor: ({ vars }) => vars.palette.background.paper,
      }}
    >
      {props.children}
      {props.caption ? (
        <Box component="figcaption" paddingX={0.5} paddingBottom={0.5} marginTop={1.5}>
          <Typography align="center">{props.caption}</Typography>
        </Box>
      ) : null}
    </Stack>
  );
};

const documentationURL = getComponentDocumentationUrl('frames');

const descriptions = {
  caption:
    'A caption that sits underneath the image. This field maps to the <figcaption> tag for accessibility purposes.',
  children: 'The content of the frame. Usually an image or a video.',
  frame: `Display a frame around your content. \n\n\n\n**Example**\n\`\`\`mdx\n<Frame caption="Title">\n  The content of the frame\n</Frame>\n\`\`\`\n\n${documentationURL}`,
};

export const frameSchema = z
  .object({
    caption: z.string().describe(descriptions.caption).optional(),
    children: z.any().describe(descriptions.children),
  })
  .describe(descriptions.frame);
